export default "__VITE_ASSET__fa5f6b0b__"